// @flow @jsx h
import { Component, h } from 'preact'
import VoiceText from '../../../../../lib/VoiceText'

import type Caption from '../../../../../lib/VoiceText'
import { connect } from '../../../../../lib/provider'

import styles from './index.css'
import '../../../../../lib/VoiceText/index.css'

type Props = {
  mp3: string,
  captions: Caption[],
  sendGaEvent: (Object) => void
}

export class _Lydtekst extends Component<Props> {
  handlePlay = (position: number) => {
    this.props.sendGaEvent({
      action: 'play',
      label: this.props.mp3,
      value: position
    })
  }

  handleStop = (position: number) => {
    this.props.sendGaEvent({
      action: 'stop',
      label: this.props.mp3,
      value: position
    })
  }

  render () {
    const propsValidated = !!this.props.mp3 && this.props.captions && this.props.captions.length > 0
    return (
      <div class={styles.lydtekst}>
        {propsValidated ? (<VoiceText
          mp3={this.props.mp3}
          captions={this.props.captions}
          onPlay={this.handlePlay}
          onStop={this.handleStop}
        />) : (<div>
          Komponenten mangler nødvendig informasjon
        </div>)}
      </div>
    )
  }
}

const connector = connect()
// const connector = connect(mapContextToProps)
export const Lydtekst = connector(_Lydtekst)
